import { createSlice } from '@reduxjs/toolkit';

// Create a slice
const LoadingSlice = createSlice({
  name: 'data',
  initialState: {
    data: [],
    status: false, 
    error: null,
  },
  reducers: {
    loadingStart: (state) => {
      state.status = true;
    },
    loadingSuccess: (state, action) => {
      state.status = false;
      state.data = action.payload;
    },
    loadingFailure: (state, action) => {
      state.status = false;
      state.error = action.payload;
    },
  },
});

export const { loadingStart, loadingSuccess, loadingFailure } = LoadingSlice.actions;

export default LoadingSlice.reducer;